module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-black-header-74efe7351105996c970be05a9d3631b9.svg";